interface DescriptionCardProps {
  description?: string;
}

export function DescriptionCard({ description }: DescriptionCardProps) {
  if (!description) return null;

  return (
    <div className="max-w-none text-gray-700 text-sm leading-relaxed prose prose-sm">
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
}
